const inlineData = typeof window === 'undefined' ? {} : window.__inline_data__

import { BailOut } from '../strategies'
import find from 'lodash/find'

const typesConsumed = []

export default {
  accept: async ({ type }) => {
    if (!type && FONTAWESOME.ENV !== 'production') {
      throw new Error('Strategy for inline data fetching requires "type"')
    }

    if (!type) return false

    return find(inlineData, (hm) => {
      const data = Array.isArray(hm.data) ? hm.data : [hm.data]

      return find(data.slice(0, 1), (record) => {
        if (record.type === type && typesConsumed.indexOf(type) === -1) {
          typesConsumed.push(type)
          return true
        } else {
          return false
        }
      })
    })
  },

  process: ({ type, preamble }) => {
    return new Promise((resolve, reject) => {
      if (Array.isArray((preamble || {}).data) || ((preamble || {}).data || {}).type === type) {
        resolve({ data: preamble })
      } else {
        // Whatever is found is not going to be useful...
        // Tell the processor to continue on to the next strategy
        reject(new BailOut())
      }
    })
  }
}
